export const CORE_API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

// Where server-side code (Server Actions, route handlers, RSC) reaches the api. The
// internal URL keeps that traffic on the private network; unset or empty falls back
// to the public URL. Browser code keeps using CORE_API_URL.
export const CORE_API_SERVER_URL = process.env.CORE_API_INTERNAL_URL || CORE_API_URL;

export const OAUTH_LOGIN_BINDING_COOKIE_DOMAIN =
  process.env.NEXT_PUBLIC_OAUTH_LOGIN_BINDING_COOKIE_DOMAIN || '';
